import type { ReactNode, Ref, RefObject } from 'react';
import { MaskedScrollArea } from '@/embedded/chat/components/masked-scrollarea';
import {
  ScrollToBottomAnchor,
  ScrollToBottomProvider,
  ScrollToBottomTrigger,
} from './scroll-to-bottom';

export function ChatScrollViewport({
  children,
  contentBoxId,
  scrollContainerRef,
  enableAutoScroll = true,
  showScrollAnchor = false,
  bottomInset = 0,
}: {
  children: ReactNode;
  contentBoxId: string;
  scrollContainerRef: RefObject<HTMLDivElement | null>;
  enableAutoScroll?: boolean;
  showScrollAnchor?: boolean;
  bottomInset?: number;
}) {
  return (
    <ScrollToBottomProvider
      containerRef={scrollContainerRef as RefObject<HTMLElement | null>}
      enableAutoScroll={enableAutoScroll}
    >
      <div className="relative min-h-0 flex-1 bg-background">
        <MaskedScrollArea
          ref={scrollContainerRef as Ref<HTMLDivElement>}
          className="h-full px-4 pt-4 md:px-5 md:pt-4"
          maskSizeStart={0}
        >
          <div
            id={contentBoxId}
            className="mx-auto flex min-h-full w-full max-w-[920px] flex-col gap-4"
            data-quote-container="true"
            data-quote-focus-class="website-conversation-message-focused"
            style={{ paddingBottom: bottomInset }}
          >
            {children}
            {showScrollAnchor ? <ScrollToBottomAnchor /> : null}
          </div>
        </MaskedScrollArea>

        {showScrollAnchor ? (
          <ScrollToBottomTrigger
            className="absolute left-1/2 z-10 -translate-x-1/2"
            style={{ bottom: `${bottomInset + 16}px` }}
          />
        ) : null}
      </div>
    </ScrollToBottomProvider>
  );
}
